import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConquistaUsuarioResponse } from 'app/shared/models/ei-models';
import { DefaultComponentsModule } from 'app/shared/modules/default-components.module';

@Component({
  selector: 'app-badge-dialog',
  standalone: true,
  imports: [DefaultComponentsModule],
  templateUrl: './badge-dialog.component.html',
  styleUrl: './badge-dialog.component.scss'
})
export class BadgeDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConquistaUsuarioResponse) { }

  async compartilhar() {
    const texto = this.data.nome || '';
    const imagem = this.data.paraCompartilhar;

    if (navigator.share && navigator.canShare && navigator.canShare({ url: imagem })) {
      try {
        await navigator.share({
          title: this.data.nome,
          text: texto,
          url: imagem,
        });
      } catch (error) {
        console.error('Erro ao compartilhar:', error);
      }
    } else {
      const textoWhats = encodeURIComponent(`${texto}\n${imagem}`);
      window.open(`https://api.whatsapp.com/send?text=${textoWhats}`, '_blank');
    }
  }

  compartilharLinkedin() {
    const texto = encodeURIComponent(this.data.nome || '');
    const imagem = encodeURIComponent(this.data.paraCompartilhar);
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${imagem}&summary=${texto}`;
    window.open(url, '_blank');
  } 
}
